<template>
    <Tooltip :is-disabled="!hasAllocations">
        <template #trigger="tooltipProps">
            <p
                :id="props.id"
                class="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:z-40 focus-visible:outline-gray-700 rounded-xs"
                :class="{ 'cursor-help': hasAllocations, 'font-bold': hasOwnAllocations }"
                :aria-describedby="hasAllocations ? tooltipProps['aria-labelledby'] : undefined"
                :popovertarget="hasAllocations ? tooltipProps.popovertarget : undefined"
                :tabindex="hasAllocations ? 0 : undefined"
            >
                {{ props.label }}

                <span v-if="hasOwnAllocations" class="font-light" :class="[props.countTextColorClass]">
                    <template v-if="own.inRange === own.total">({{ own.total }})</template>
                    <template v-else>({{ own.inRange }}/{{ own.total }})</template>
                </span>
            </p>
        </template>

        <template #text>
            <OwnAndForeignAllocationCountTooltipText :allocation-count="props.allocationCount" />
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import type { OwnAndForeignAllocationCount } from '@/components/Timeline/logic/allocationCounts';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { computed } from 'vue';
import OwnAndForeignAllocationCountTooltipText from './OwnAndForeignAllocationCountTooltipText.vue';

type LocationOwnAndForeignAllocationCountLabelProps = {
    id: string;
    label: string;
    allocationCount: OwnAndForeignAllocationCount;
    countTextColorClass: string;
};

const props = defineProps<LocationOwnAndForeignAllocationCountLabelProps>();

const own = computed(() => props.allocationCount.own);
const hasOwnAllocations = computed(() => own.value.total > 0);
const hasAllocations = computed(() => hasOwnAllocations.value || props.allocationCount.foreign.inRange > 0);
</script>
